'use client';

import { useQueryPropertyCategories } from '@src/apis/shared/get-property-categories';
import Button from '@src/components/atoms/button';
import cn from 'classnames';

// Assets
import ICheckedBlack from '@public/svg/i-checked-black.jsx';

const ModalPropertyType = ({ onSelectPropertyType, selectedPropertyType }) => {
  const { data: listPropertyCategories } =
    useQueryPropertyCategories();
  

  return (
    <div>
      <div className="px-6 py-4">
        <p className="font-satoshi-bold text-[21px] leading-[25.2px] text-[#252526]">
          Properti apa yang ingin dijual?
        </p>
        <p className="font-satoshi text-[14px] leading-[19.6px] text-[#686A68]">
          Pilih jenis properti Anda.
        </p>
      </div>

      <div className="flex items-center flex-wrap gap-2 px-6 py-2">
        {!!listPropertyCategories?.length &&
          listPropertyCategories.map((list, index) => {
            const isSelected = selectedPropertyType?.id === list.id;
            return (
              <Button
                onClick={() => {
                  onSelectPropertyType(list)
                }}
                key={`list-property-${index}`}
                className={cn({
                  "h-[32px] !py-0 !px-[12px] !font-satoshi": true,
                  "bg-white !text-[#252526] border border-solid border-[#DEDFDE]": !isSelected,
                  "bg-[#252526] !text-white": isSelected,
                })}
              >
                {list.name}
                {isSelected && <ICheckedBlack />}
              </Button>
            );
          })}
      </div>
    </div>
  );
};

export default ModalPropertyType;
